import React from 'react';
import PropTypes from 'prop-types';
import { Heading, ModalDialog } from '@zillow/constellation';

function BlockedUserModal({ body }) {
  return (
    <ModalDialog
      wide
      {...{
        closeButton: null,
        isOpen: Boolean(body),
        mediaQuery: {
          xs: { fullScreen: true },
          md: { fullScreen: false },
        },
        header: <Heading level={4}>Alert</Heading>,
        body,
      }}
    />
  );
}

BlockedUserModal.propTypes = {
  body: PropTypes.node.isRequired,
};

export default BlockedUserModal;
